












import Vue from 'vue';
import MusicCardList from '@/components/MusicCardList.vue';

export default Vue.extend({
  name: 'FavoriteView',
  components: {
    MusicCardList,
  },
});
